<style>
  .feather-icon{
    line-height: 24px;
    vertical-align: middle;
  }
  .green-spore {
    color: #34C672 !important;
  }
  .bg-success-spore {
    background-color: rgba(225,246,234,1) !important;
  }
  .bg-danger-spore {
    background-color: rgba(252,68,110,1) !important;
  }
</style>
<template>
  <div class="device-info" :class="[`${custom}`]">
    <div class="shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle"  :class="[`bg-${status}`]" >
      <feather-icon icon="CheckIcon" svgClasses="h-5 w-4 green-spore align-middle" v-if="status == 'primary'" />
      <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-4 text-white" v-if="status == 'warning'" />
      <iconBase iconName="alarm" :width="16" :height="20" iconColor="#ffff" class="align-middle" v-else-if="status == 'danger-spore'"><iconAlarm/></iconBase>
      <iconBase iconName="cancel" :width="16" :height="20" iconColor="#ffff" class="align-middle" v-else-if="status == 'grey'"><iconCancel/></iconBase>
      <feather-icon icon="CheckIcon" svgClasses="h-5 w-4 green-spore stroke-current" v-else />
    </div>
    <span v-show="percent.length > 0" class="ml-5 font-bold align-middle" :class="[`text-${status} `]">{{percent}} <span v-if="percent != undefined">%</span></span>
    <span v-show="description.length > 0" class="ml-2 text-xs align-middle">{{description}}</span>
  </div>
</template>
<script>
import iconBase from '@/components/icons/iconBase'
import iconAlarm from '@/components/icons/iconAlarm'
import iconCancel from '@/components/icons/iconCancel'

export default {
  components: {
    iconBase,
    iconAlarm,
    iconCancel
  },
  props:{
    status: String,
    percent: {
      type: String,
      default: ''
    },
    custom: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>